import { FC } from "react";
import { AppointmentRequestTable } from "@/components/appointmentRequest/appointmentRequestTable";
import RestrictedPage from "@/consumer/restrictedPage";

const AppointmentRequestTableView: FC = () => {
  return (
    <RestrictedPage permissionRequired="frontend_view_appointment_request">
      <AppointmentRequestTable />
    </RestrictedPage>
  );
};

export default AppointmentRequestTableView;
